/**
 * Maison Montrose — favoris produits.
 *
 * Stockés dans le `localStorage` du navigateur, sous forme de handles.
 * C'est le seul stockage qu'un thème peut écrire : la boutique n'a pas
 * d'application de liste d'envies, et l'API Storefront ne laisse pas
 * écrire un métachamp client depuis la vitrine.
 *
 * Conséquence assumée, à dire au client : la liste vit sur l'appareil,
 * elle ne suit pas d'un téléphone à un ordinateur.
 */

(function () {
  const CLE = 'montrose:favoris';

  function lire() {
    try {
      const brut = JSON.parse(window.localStorage.getItem(CLE));
      return Array.isArray(brut) ? brut.filter((h) => typeof h === 'string') : [];
    } catch (erreur) {
      /* navigation privée, stockage bloqué : on dégrade en liste vide */
      return [];
    }
  }

  function ecrire(liste) {
    try {
      window.localStorage.setItem(CLE, JSON.stringify(liste));
    } catch (erreur) {
      /* rien à faire : la session courante fonctionne quand même */
    }
    document.dispatchEvent(new CustomEvent('mon:favoris', { detail: { liste: liste } }));
  }

  const MonFavoris = {
    liste: lire,
    contient(handle) {
      return lire().indexOf(handle) !== -1;
    },
    nombre() {
      return lire().length;
    },
    basculer(handle) {
      const liste = lire();
      const i = liste.indexOf(handle);
      if (i === -1) {
        liste.unshift(handle);
      } else {
        liste.splice(i, 1);
      }
      ecrire(liste);
      return i === -1;
    },
    retirer(handle) {
      const liste = lire().filter((h) => h !== handle);
      ecrire(liste);
    },
  };

  window.MonFavoris = MonFavoris;

  /* ---------- Boutons ---------- */

  function synchroniser() {
    const liste = lire();
    document.querySelectorAll('[data-mon-favori]').forEach(function (bouton) {
      const actif = liste.indexOf(bouton.dataset.monFavori) !== -1;
      bouton.setAttribute('aria-pressed', String(actif));
      bouton.classList.toggle('is-actif', actif);
      /* Deux libellés distincts : celui qui est lu (il nomme le produit,
         hors contexte dans une liste de liens) et celui qui est vu (court,
         le nom du produit est déjà à côté). */
      const lu = actif ? bouton.dataset.labelRetirer : bouton.dataset.labelAjouter;
      if (lu) bouton.setAttribute('aria-label', lu);
      const texte = bouton.querySelector('[data-mon-favori-texte]');
      const vu = actif ? bouton.dataset.texteRetirer : bouton.dataset.texteAjouter;
      if (texte && vu) texte.textContent = vu;
    });

    document.querySelectorAll('[data-mon-favoris-compteur]').forEach(function (el) {
      el.textContent = liste.length;
      el.hidden = liste.length === 0;
    });
  }

  document.addEventListener('click', function (evenement) {
    const bouton = evenement.target.closest('[data-mon-favori]');
    if (!bouton) return;
    /* Les cartes du catalogue sont des liens : sans ça, le clic navigue. */
    evenement.preventDefault();
    evenement.stopPropagation();
    MonFavoris.basculer(bouton.dataset.monFavori);
  });

  document.addEventListener('mon:favoris', synchroniser);
  document.addEventListener('DOMContentLoaded', synchroniser);
  if (document.readyState !== 'loading') synchroniser();
})();
